import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';

const COIN_ICONS = [
  'assets/icons/ico_usdc_3d.svg',
  'assets/icons/ico_btc_3d.svg',
];

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnDestroy {
  isLoading: boolean = false;
  coins = COIN_ICONS;
  private subscriptions: Subscription = new Subscription();

  constructor(private loadingService: LoadingService) {
    const loadingSubscription = this.loadingService.isLoading$.subscribe(
      (isLoading) => {
        this.isLoading = isLoading;
      },
    );
    this.subscriptions.add(loadingSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
